import { bunja } from 'bunja';
import { atom } from 'jotai';

import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';

class RafLoop {
  private running = false;
  private frameId = 0;

  constructor(private callback: () => void) {}

  start() {
    if (this.running) return;
    this.running = true;
    this.frameId = requestAnimationFrame(this.tick);
  }

  stop() {
    this.running = false;
    cancelAnimationFrame(this.frameId);
  }

  private tick = () => {
    if (!this.running) return;
    this.callback();
    this.frameId = requestAnimationFrame(this.tick);
  };
}

export const globalTimerBunja = bunja(() => {
  const store = bunja.use(JotaiStoreScope);

  const nowRealtimeAtom = atom<number>(Date.now());
  const nowPerSecondAtom = atom((get) => {
    const now = get(nowRealtimeAtom);
    return Math.trunc(now / 1000) * 1000;
  });

  bunja.effect(() => {
    const updateNow = () => store.set(nowRealtimeAtom, Date.now());
    const loop = new RafLoop(updateNow);
    loop.start();
    document.addEventListener('visibilitychange', updateNow);
    return () => {
      loop.stop();
      document.removeEventListener('visibilitychange', updateNow);
    };
  });

  return { nowRealtimeAtom, nowPerSecondAtom };
});
globalTimerBunja.debugLabel = 'globalTimerBunja';
